import React from "react";

const DemoProgress = ({ step = "compose", delivery = {} }) => {
  const resultReceived = delivery.etv === "received" && delivery.app === "received";
  const contentLabel = {
    announcement: "Pengumuman",
    kuliah: "Kuliah",
    etv_mode: "Paparan ETV",
  }[delivery.contentType] || "Pengumuman";

  return (
    <div className="demo-progress" aria-label="Kemajuan demo">
      <span className={step === "compose" ? "is-active" : "is-complete"}>1. {contentLabel}</span>
      <span className={step === "delivered" ? "is-complete" : ""}>2. Hantar</span>
      <span className={resultReceived ? "is-complete is-success" : ""}>
        3. Lihat hasil{resultReceived ? " ✓" : ""}
      </span>
    </div>
  );
};

export default DemoProgress;
